/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Risk-Model-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 10/22/18
 * Copyright All Rights Reserved
 */

import get from 'lodash/fp/get';
import { createSelector } from 'reselect';

const selectTipId = (_, props) => props.tipId;

const selectTips = state => state.ui.tooltips;

export const tooltipBody = createSelector(
  selectTips,
  selectTipId,
  (tips, id) => get(`${id}.body`, tips),
);

export const tooltipHeader = createSelector(
  selectTips,
  selectTipId,
  (tips, id) => get(`${id}.header`, tips),
);



// WEBPACK FOOTER //
// ./js/selectors/ui/tooltips.js